import { styled, Title, CustomLink, Heading } from '@teko/ds-desktop';
import dynamic from 'next/dynamic';
import React from 'react';
import { t } from '../../i18n.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RightOutlined = dynamic(() => import('@teko/ds-icon').then((mod) => mod.RightOutlined));
const Wrapper = styled.div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = styled.div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className,
  style,
  isHeadingTitle = false
}) => {
  const { isMobile } = useDevice();
  const BlockTitle = isHeadingTitle ? StyledHeading : Title;
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor,
    style
  }, link ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CustomLink, __spreadValues({}, link), /* @__PURE__ */ React.createElement(BlockTitle, {
    level: 2,
    className: "title",
    color: titleColor || "textTitle"
  }, title)), /* @__PURE__ */ React.createElement(CustomLink, __spreadValues({}, link), /* @__PURE__ */ React.createElement(SeeAll, __spreadValues({
    color: link.color || ""
  }, tracking), t("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ React.createElement(RightOutlined, {
    color: link.color
  })))) : /* @__PURE__ */ React.createElement(BlockTitle, {
    level: 2,
    className: "title",
    color: titleColor || "textTitle"
  }, title));
};
const StyledHeading = styled(Heading)`
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
`;

export { BlockHeader };
